export const ADMIN_TYPE = "ADMIN"
export const USER_TYPE = "USER"
export const USER_TYPE_ID = 0
export const ADMIN_TYPE_ID = 2
export const BUSINESS_UNIT_TYPE = 1 //0;
export const CORPORATE_TYPE = 2 //1;
export const ASSIGN_ACOUNT_TYPES = [
  { value: BUSINESS_UNIT_TYPE, label: "Business Unit" },
  { value: CORPORATE_TYPE, label: "Corporate" },
]
